import {parseISO} from 'date-fns';
import {AppThunk} from '../../createStore';
import {updateWorkday} from '../../data/workday';
import {cancelParkingReservation, getParkingReservationByDate} from '../../data/parkingReservation';
import {Workday} from '../../data/entities';
import {cancelWorkspaceReservation, getWorkspaceReservationByDate} from '../../data/workspaceReservation';
import {getParkingLotsByBuildingId} from '../../data';

export const updateWorkdayAndReservations =
  (workday: Workday): AppThunk<Promise<void>> =>
  async (dispatch, getState) => {
    await dispatch(updateWorkday(workday)).unwrap();
    const state = getState();
    const startDate = workday.startDate;

    const workspaceReservation = getWorkspaceReservationByDate(state, parseISO(startDate));
    const workspaceReservationId = workspaceReservation?.id;
    workspaceReservationId && dispatch(cancelWorkspaceReservation(workspaceReservationId));

    const parkingReservation = getParkingReservationByDate(getState(), startDate);
    if (parkingReservation) {
      if (workday.status === 'NotWorking' || workday.status === 'WorkingRemotely')
        dispatch(cancelParkingReservation(parkingReservation.id));
      else {
        const parkingLots = getParkingLotsByBuildingId(getState(), workday.nodeId);
        const foundParkingLot = parkingLots.find((parkingLot) => parkingLot.id === parkingReservation.parkingLotId);
        !foundParkingLot && dispatch(cancelParkingReservation(parkingReservation.id));
      }
    }
  };
